import { useParams } from "react-router-dom";
import { AvatarEdit } from "../components/ContactWithPresenter/AvatarEdit";

export const ContactEditPage = () => {
  const { id } = useParams();
  return id ? <AvatarEdit id={id} /> : null;
};